import { FilterGroup } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '../types';
import { getActivityStatusFilter } from './activityStatus/activityStatus';
import { getCompleteFilter } from './complete/complete';
import { getDaysIdleFilter } from './daysIdle/daysIdle';
import { getIncompleteFilter } from './incomplete/incomplete';
import { getInterviewFilter } from './interview/interview';
import { getRecordedInterviewFilter } from './recordedInterviews/recordedInterviews';

export const getEngagementGroupFilters = (props: IGetFilterGroupsProps): FilterGroup => {
  return {
    name: 'ENGAGEMENT',
    filters: [
      getCompleteFilter(props),
      getIncompleteFilter(props),
      getInterviewFilter(props),
      getRecordedInterviewFilter(props),
      getActivityStatusFilter(props),
      getDaysIdleFilter(props),
    ],
  };
};
